const localStoreUtil = {
  store_data: (key:any, data:any) => {
    // Store JWT tokens as plain strings without JSON stringification
    if (key === "token" || key === "Admintoken") {
      localStorage.setItem(key, data);
    } else {
      localStorage.setItem(key, JSON.stringify(data));
    }
    return true;
  },

  get_data: (key:any) => {
    const item = localStorage.getItem(key);

    if (!item) return;
    // JWT tokens are stored as plain strings
    if (key === "token" || key === "Admintoken") {
      return item;
    }
    return JSON.parse(item);
  },

  remove_data: (key:any) => {
    localStorage.removeItem(key);
    return true;
  },

  remove_all: () => {
    localStorage.clear();
    return true;
  },
};

export default localStoreUtil;
